export const MISC_PAYMENT_TYPES = {
  BANK_WIRE: 'BANK_WIRE',
  BLUE_MEDIA_BLIK: 'BLUE_MEDIA_BLIK',
  BLUE_MEDIA_CARD: 'BLUE_MEDIA_CARD',
  BLUE_MEDIA: 'BLUE_MEDIA',
  CASH: 'CASH',
  PAYNOW: 'PAYNOW',
  PAYPO: 'PAYPO',
  STRIPE_CARD: 'STRIPE_CARD',
  STRIPE_LINK: 'STRIPE_LINK',
  TPAY: 'TPAY',
  MONTONIO_LINK_CARD: 'MONTONIO_LINK_CARD',
  MONTONIO_LINK_BANK: 'MONTONIO_LINK_BANK',
} as const;

export const PAYU_PAYMENT_TYPES = {
  PAYU_BLIK: 'PAYU_BLIK',
  PAYU_BLIK_PAY_LATER: 'PAYU_BLIK_PAY_LATER',
  PAYU_CARD: 'PAYU_CARD',
  PAYU_GOOGLE_PAY: 'PAYU_GOOGLE_PAY',
  PAYU_APPLE_PAY: 'PAYU_APPLE_PAY',
  PAYU: 'PAYU',
  PAYU_PAYPO: 'PAYU_PAYPO',
} as const;

const PAYMENT_TYPES = { ...PAYU_PAYMENT_TYPES, ...MISC_PAYMENT_TYPES } as const;

export type PaymentType = (typeof PAYMENT_TYPES)[keyof typeof PAYMENT_TYPES];

export default PAYMENT_TYPES;
